import AddEmailInfoComponent from './AddEmailInfoContainer';

export default AddEmailInfoComponent;